import Swiper, {
    Navigation,
    Pagination
} from 'swiper';

export default class SolutionSlider {

    slideClass = 'jet-listing-grid__item';

    wrapperClass = 'jet-listing-grid__items';

    swiperOptions = {
        modules: [
            Pagination,
            Navigation
        ],
        loop: false,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 20,
            }
        },
    };

    constructor() {
        this.addEvents();
    }

    addEvents() {

        const solutionSlider = document.querySelectorAll('.solutionSlider');
        if (!solutionSlider) return;
        const that = this;

        window.addEventListener('load', e => {
            setTimeout(() => {
                solutionSlider.forEach((slider) => {
                    const swiperElements = slider.querySelectorAll('.jet-listing-grid');
                    if (!swiperElements) return;
                    swiperElements.forEach((swiperElement) => {
                        // init swiper
                        swiperElement.classList.add('swiper-container');
                        let swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                        if(swiperSlides.length > 3 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                            swiperElement.innerHTML += (`
                                <div class="swiper-button-prev">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none"><g filter="url(#filter0_d_195_4461)"><circle cx="48" cy="44" r="28" fill="white"/></g><path d="M55.9375 44.9169L49.0597 52.5734C48.9528 52.6924 48.8235 52.7891 48.6793 52.8581C48.535 52.9272 48.3785 52.9671 48.2188 52.9756C48.0591 52.9842 47.8993 52.9612 47.7485 52.908C47.5976 52.8548 47.4588 52.7724 47.3398 52.6655C47.2208 52.5586 47.1241 52.4294 47.055 52.2851C46.986 52.1408 46.9461 51.9844 46.9375 51.8246C46.929 51.6649 46.952 51.5051 47.0052 51.3543C47.0584 51.2035 47.1408 51.0646 47.2477 50.9456L52.1774 45.4706L38.1397 46.2226C37.8185 46.2398 37.5036 46.1287 37.2643 45.9138C37.025 45.6988 36.8809 45.3975 36.8636 45.0763C36.8464 44.7551 36.9575 44.4402 37.1725 44.2009C37.3875 43.9616 37.6887 43.8174 38.0099 43.8002L52.0477 43.0482L46.5612 38.1312C46.3209 37.9154 46.1762 37.6129 46.1589 37.2903C46.1416 36.9678 46.2532 36.6516 46.469 36.4113C46.6849 36.171 46.9874 36.0263 47.3099 36.0091C47.6324 35.9918 47.9486 36.1033 48.1889 36.3192L55.8454 43.197C55.9649 43.3035 56.0622 43.4327 56.1316 43.577C56.201 43.7213 56.2412 43.8779 56.2497 44.0378C56.2583 44.1977 56.2351 44.3577 56.1815 44.5086C56.128 44.6594 56.045 44.7982 55.9375 44.9169Z" fill="#262626"/><defs><filter id="filter0_d_195_4461" x="0" y="0" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="10"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_4461"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_446" result="shape"/></filter></defs></svg>
                                </div>
                                <div class="swiper-button-next">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none"><g filter="url(#filter0_d_195_4462)"><circle cx="48" cy="44" r="28" fill="white"/></g><path d="M55.9375 44.9169L49.0597 52.5734C48.9528 52.6924 48.8235 52.7891 48.6793 52.8581C48.535 52.9272 48.3785 52.9671 48.2188 52.9756C48.0591 52.9842 47.8993 52.9612 47.7485 52.908C47.5976 52.8548 47.4588 52.7724 47.3398 52.6655C47.2208 52.5586 47.1241 52.4294 47.055 52.2851C46.986 52.1408 46.9461 51.9844 46.9375 51.8246C46.929 51.6649 46.952 51.5051 47.0052 51.3543C47.0584 51.2035 47.1408 51.0646 47.2477 50.9456L52.1774 45.4706L38.1397 46.2226C37.8185 46.2398 37.5036 46.1287 37.2643 45.9138C37.025 45.6988 36.8809 45.3975 36.8636 45.0763C36.8464 44.7551 36.9575 44.4402 37.1725 44.2009C37.3875 43.9616 37.6887 43.8174 38.0099 43.8002L52.0477 43.0482L46.5612 38.1312C46.3209 37.9154 46.1762 37.6129 46.1589 37.2903C46.1416 36.9678 46.2532 36.6516 46.469 36.4113C46.6849 36.171 46.9874 36.0263 47.3099 36.0091C47.6324 35.9918 47.9486 36.1033 48.1889 36.3192L55.8454 43.197C55.9649 43.3035 56.0622 43.4327 56.1316 43.577C56.201 43.7213 56.2412 43.8779 56.2497 44.0378C56.2583 44.1977 56.2351 44.3577 56.1815 44.5086C56.128 44.6594 56.045 44.7982 55.9375 44.9169Z" fill="#262626"/><defs><filter id="filter0_d_195_4462" x="0" y="0" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="10"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_4462"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_446" result="shape"/></filter></defs></svg>
                                </div>
                                <div class="swiper-pagination relative"></div>
                            `);
                        }else{
                            swiperElement.classList.add('not-swipper');
                        }
                        const swiperWrapper = swiperElement.querySelector(`.${this.wrapperClass}`);
                        swiperWrapper.setAttribute('class', 'swiper-wrapper');

                        swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                        swiperSlides.forEach((el) => {
                            el.setAttribute('class', 'swiper-slide');
                        });
                        if(swiperSlides.length > 3 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                            new Swiper(swiperElement, this.swiperOptions);
                        }
                    });
                });
            }, 500)


        });
    }
}
